const select = 'id,reportTokenId,headers,dataType,logs,ip,method,created,isSuccessfullyRequest';

export default {
  paged: {
    select: `${select}`,
    searchSelect: ['method', 'dataType', 'headers', 'logs'],
  },
  detail: {
    select: `${select}`,
  },
};
